/**
 * Artist simplified view: row grid by default, masonry on request.
 * The choice is stored only for artist pages.
 */
(function () {
  "use strict";

  var layout = document.querySelector("[data-artist-grid-controls]");
  var group = document.querySelector("[data-artist-layout-toggle]");
  if (!layout || !group) return;

  var KEY = "artfolio-artist-layout";

  function read() {
    try {
      var value = localStorage.getItem(KEY);
      if (value === "masonry" || value === "row") return value;
    } catch (err) {}
    return "row";
  }

  function apply(mode, persist) {
    var next = mode === "masonry" ? "masonry" : "row";
    layout.setAttribute("data-artist-layout", next);
    Array.prototype.forEach.call(group.querySelectorAll("[data-artist-layout-value]"), function (btn) {
      var on = btn.getAttribute("data-artist-layout-value") === next;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
    if (persist) {
      try { localStorage.setItem(KEY, next); } catch (err) {}
    }
  }

  apply(read(), false);
  group.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-artist-layout-value]");
    if (!btn || !group.contains(btn)) return;
    apply(btn.getAttribute("data-artist-layout-value"), true);
  });
})();
